import firebase from 'firebase';
import {environment} from "./environments/environment";

export default firebase.initializeApp(environment.fbConfig);


